import React from 'react';
import { BsCheckCircleFill } from "react-icons/bs";
import { IoCloseCircle } from "react-icons/io5";

const Comparison = () => {
    return (
        <>
            <section id='comparison'>
                <div className="container">
                    <h2 className="title">What makes us better amongst the Competitors?</h2>
                    <p className="desc">Choosing the right academy for language proficiency and test preparation is crucial for achieving your educational and career goals. We set ourselves apart with exceptional courses in OET, IELTS, PTE, German, TOEFL, NCLEX-RN, and CBT, making us the preferred choice among aspirants. Our comparison table highlights why Neethu's Academy stands out in the market.</p>
                </div>
                <div className="comparisonMain">
                    <div className="comparisonList">
                        <div className="comparisonBox">
                            <div className="comparisonBoxHead">
                                <h3>Neethus Academy</h3>
                            </div>
                            <div className="comparisonBoxBody">
                                <ul>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>OET, IELTS, PTE, German, TOEFL, CBT, NCLEX-RN</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>Experienced specialization</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>Expert Faculty</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>Consistent success stories</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>Individual attention 24/7</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>Flexible online and offline options</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>Updated self-prepared materials.</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>Renowned reputation among students</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>Competitive pricing with value-added services</h4>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="comparisonBox">
                            <div className="comparisonBoxHead">
                                <h3>Competitors</h3>
                            </div>
                            <div className="comparisonBoxBody">
                                <ul>
                                    <li>
                                        <div className="icon iconGreen">
                                            <BsCheckCircleFill />
                                        </div>
                                        <div className="details">
                                            <h4>OET, IELTS, PTE, German, TOEFL, CBT, NCLEX-RN</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconRed">
                                            <IoCloseCircle />
                                        </div>
                                        <div className="details">
                                            <h4>Limited focus</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconRed">
                                            <IoCloseCircle />
                                        </div>
                                        <div className="details">
                                            <h4>Mixed feedback</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconRed">
                                            <IoCloseCircle />
                                        </div>
                                        <div className="details">
                                            <h4>Moderate success rate</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconRed">
                                            <IoCloseCircle />
                                        </div>
                                        <div className="details">
                                            <h4>Very few student centric programs</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconRed">
                                            <IoCloseCircle />
                                        </div>
                                        <div className="details">
                                            <h4>No flexibility</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconRed">
                                            <IoCloseCircle />
                                        </div>
                                        <div className="details">
                                            <h4>Only basic study materials</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconRed">
                                            <IoCloseCircle />
                                        </div>
                                        <div className="details">
                                            <h4>Not Renowned</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon iconRed">
                                            <IoCloseCircle />
                                        </div>
                                        <div className="details">
                                            <h4>Low price with no extra services</h4>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="comparisonFooter">
                        <a href="tel:+919633133374">Join Now</a>
                        <p>Our team can't wait to welcome you.</p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Comparison;